import {
  Button,
  ButtonGroup,
  Popover,
  useDisclosure,
  Fieldset,
  CheckboxGroup,
  For,
  Checkbox,
} from "@chakra-ui/react";
import { t } from "i18next";
import { observer } from "mobx-react";
import { useState, useEffect } from "react";
import { FilterTag } from "./FilterTag";
import { useStores } from "../../../../shared/stores/RootStore";
import { CustomPopover } from "../../../../shared/views/CustomPopover";
import { AddFilterButton } from "./AddFilterButton";

const HlaVerifiedFiltersBase: React.FC = () => {
  const { open, onToggle, onClose } = useDisclosure();
  const { filterStore } = useStores();

  const [newFilters, setNewFilters] = useState<boolean[]>([]);

  useEffect(() => {
    if (open) {
      setNewFilters([...filterStore.hlaVerifiedFilters]);
    }
    //eslint-disable-next-line
  }, [open]);

  const handleClear = () => {
    setNewFilters([]);
  };

  const handleSubmit = () => {
    filterStore.setHlaVerifiedFilters(newFilters);
    onClose();
  };

  const removeActiveFilter = (value: boolean) => {
    filterStore.setHlaVerifiedFilters(
      filterStore.hlaVerifiedFilters.filter((x) => x !== value),
    );
  };

  return (
    <>
      <CustomPopover
        trigger={<AddFilterButton label="Verification" onClick={onToggle} />}
        asChild={false}
        open={open}
        onClose={onClose}
        w={500}
        maxH="460px"
      >
        {open && (
          <>
            <Popover.Header>Filter by verification</Popover.Header>
            <Popover.Body overflowY="auto" px={6}>
              <Fieldset.Root>
                <CheckboxGroup>
                  <Fieldset.Content flexDir="row" flexWrap={"wrap"} gap={2}>
                    <For each={options}>
                      {(option) => (
                        <Checkbox.Root
                          key={option.value.toString()}
                          checked={newFilters.includes(option.value)}
                          onCheckedChange={({ checked }) => {
                            setNewFilters((prev) =>
                              checked
                                ? [...prev, option.value]
                                : prev.filter((t) => t !== option.value),
                            );
                          }}
                          colorPalette={"primary"}
                        >
                          <Checkbox.HiddenInput />
                          <Checkbox.Control />
                          <Checkbox.Label fontWeight={"normal"} fontSize={"xs"}>
                            {option.label}
                          </Checkbox.Label>
                        </Checkbox.Root>
                      )}
                    </For>
                  </Fieldset.Content>
                </CheckboxGroup>
              </Fieldset.Root>
            </Popover.Body>
            <Popover.Footer display="flex" justifyContent="flex-end">
              <ButtonGroup colorPalette={"primary"} size={"sm"}>
                <Button onClick={handleClear} disabled={!newFilters.length}>
                  {t("map:filters.clearButton")}
                </Button>
                <Button onClick={handleSubmit}>
                  {t("map:filters.submitButton")}
                </Button>
              </ButtonGroup>
            </Popover.Footer>
          </>
        )}
      </CustomPopover>

      {!!filterStore.hlaVerifiedFilters.length &&
        filterStore.hlaVerifiedFilters.map((value, i) => (
          <FilterTag
            key={i}
            onClose={() => {
              removeActiveFilter(value);
            }}
          >
            {value ? "Verified" : "Not verified"}
          </FilterTag>
        ))}
    </>
  );
};

export const HlaVerifiedFilters = observer(HlaVerifiedFiltersBase);

const options = [
  { value: true, label: "Verified" },
  { value: false, label: "Not verified" },
];
